import { Box } from '@mui/material'
import { Route, Routes, useLocation } from 'react-router-dom'
import AccountDelete from './pages/AccountDelete'
import Home from './pages/Home'
import PrivacyPolicy from './pages/PrivacyPolicy'
import Eula from './pages/Eula'
import SiteNav from './components/brand/SiteNav'
import SiteFooter from './components/brand/SiteFooter'

const routes = [
  { path: '/', element: <Home /> },
  { path: '/privacy', element: <PrivacyPolicy /> },
  { path: '/eula', element: <Eula /> },
  { path: '/accountDelete', element: <AccountDelete /> },
]

const App = () => {
  const { pathname } = useLocation()

  // The shared nav renders on every page except Home, which carries its logo
  // inline in the hero instead. Unknown paths fall through to Home, so they get
  // no nav either.
  const showNav = routes.some((r) => r.path !== '/' && r.path === pathname)

  return (
    <>
      {showNav && <SiteNav />}
      <Box component="main">
        <Routes>
          {routes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
          <Route path="*" element={<Home />} />
        </Routes>
      </Box>
      <SiteFooter />
    </>
  )
}

export default App
